import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/panzhijing/\u86CB\u5377\u79D1\u6280/danjuan-admin/node_modules/_@babel_runtime-corejs2@7.26.0@@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import adminUserApi from '@/api/adminuser';
import dateutil from "../../utils/dateutils";
import * as _ from 'lodash';
var state = {
  permissionList: [],
  roleList: [],
  userListTotal: 0,
  userList: []
};
var mutations = {
  SET_USER_LIST: function SET_USER_LIST(state, users) {
    state.userList = users;
  },
  SET_ROLE_LIST: function SET_ROLE_LIST(state, roles) {
    state.roleList = roles;
  },
  SET_PERMISSION_LIST: function SET_PERMISSION_LIST(state, permissions) {
    state.permissionList = permissions;
  },
  ROLELiIST_TOTAL: function ROLELiIST_TOTAL(state, permissions) {
    state.userListTotal = permissions;
  }
};
var actions = {
  // get admin users
  getAdminUsers: function () {
    var _getAdminUsers = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, params) {
      var commit, _yield$adminUserApi$g, data, status, message, total;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            _context.prev = 1;
            _context.next = 4;
            return adminUserApi.getAdminUsers(params);
          case 4:
            _yield$adminUserApi$g = _context.sent;
            data = _yield$adminUserApi$g.data;
            status = _yield$adminUserApi$g.status;
            message = _yield$adminUserApi$g.message;
            total = _yield$adminUserApi$g.total;
            if (!(status === '0')) {
              _context.next = 16;
              break;
            }
            if (data) {
              data.forEach(function (item) {
                if (item.roles) {
                  item.rolesText = _.join(item.roles.map(function (i) {
                    return i.name;
                  }), ',');
                }
                if (item.permissions) {
                  item.permissionCount = item.permissions.length;
                }
                item.createdOnText = dateutil.formatStandardTime(item.createdOn);
                item.updatedOnText = dateutil.formatStandardTime(item.updatedOn);
              });
            }
            commit('SET_USER_LIST', data);
            commit('ROLELiIST_TOTAL', total || 0);
            return _context.abrupt("return", data);
          case 16:
            return _context.abrupt("return", Promise.reject(message));
          case 17:
            _context.next = 22;
            break;
          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", Promise.reject('异常：' + _context.t0));
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 19]]);
    }));
    function getAdminUsers(_x, _x2) {
      return _getAdminUsers.apply(this, arguments);
    }
    return getAdminUsers;
  }(),
  getAdminRoles: function () {
    var _getAdminRoles = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2, params) {
      var commit, _yield$adminUserApi$g2, data, status, message;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref2.commit;
            _context2.prev = 1;
            console('loading admin roles');
            _context2.next = 5;
            return adminUserApi.getAdminRoles();
          case 5:
            _yield$adminUserApi$g2 = _context2.sent;
            data = _yield$adminUserApi$g2.data;
            status = _yield$adminUserApi$g2.status;
            message = _yield$adminUserApi$g2.message;
            if (!(status === '0')) {
              _context2.next = 15;
              break;
            }
            if (data) {
              data.forEach(function (item) {
                if (item.permissions) {
                  item.permissionCount = item.permissions.length;
                  item.permissionsText = _.join(item.permissions.map(function (i) {
                    return i.name;
                  }), ', ');
                } else {
                  item.permissionsText = '';
                  item.permissionCount = 0;
                }
              });
            }
            commit('SET_ROLE_LIST', data);
            return _context2.abrupt("return", data);
          case 15:
            return _context2.abrupt("return", Promise.reject(message));
          case 16:
            _context2.next = 21;
            break;
          case 18:
            _context2.prev = 18;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", Promise.reject('异常：' + _context2.t0));
          case 21:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 18]]);
    }));
    function getAdminRoles(_x3, _x4) {
      return _getAdminRoles.apply(this, arguments);
    }
    return getAdminRoles;
  }(),
  /**
   * 获取管理员用户的权限列表
   * @param commit
   * @param params
   * @returns {Promise<*|Promise<never>|undefined>}
   */
  getAdminPermission: function () {
    var _getAdminPermission = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref3, params) {
      var commit, _yield$adminUserApi$g3, data, status, message;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref3.commit;
            _context3.prev = 1;
            console('loading admin permissions');
            _context3.next = 5;
            return adminUserApi.getAdminPermissions();
          case 5:
            _yield$adminUserApi$g3 = _context3.sent;
            data = _yield$adminUserApi$g3.data;
            status = _yield$adminUserApi$g3.status;
            message = _yield$adminUserApi$g3.message;
            if (!(status === '0')) {
              _context3.next = 14;
              break;
            }
            commit('SET_PERMISSION_LIST', data);
            return _context3.abrupt("return", data);
          case 14:
            return _context3.abrupt("return", Promise.reject(message));
          case 15:
            _context3.next = 20;
            break;
          case 17:
            _context3.prev = 17;
            _context3.t0 = _context3["catch"](1);
            return _context3.abrupt("return", Promise.reject('异常：' + _context3.t0));
          case 20:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 17]]);
    }));
    function getAdminPermission(_x5, _x6) {
      return _getAdminPermission.apply(this, arguments);
    }
    return getAdminPermission;
  }(),
  updateAdminRolePermissions: function () {
    var _updateAdminRolePermissions = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref4, _ref5) {
      var commit, dispatch, roleId, roleInfo, _yield$adminUserApi$u, data, status, message;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref4.commit, dispatch = _ref4.dispatch;
            roleId = _ref5.roleId, roleInfo = _ref5.roleInfo;
            _context4.prev = 2;
            _context4.next = 5;
            return adminUserApi.updateAdminRolePermissions(roleId, roleInfo);
          case 5:
            _yield$adminUserApi$u = _context4.sent;
            data = _yield$adminUserApi$u.data;
            status = _yield$adminUserApi$u.status;
            message = _yield$adminUserApi$u.message;
            if (!(status === '0')) {
              _context4.next = 14;
              break;
            }
            dispatch('getAdminRoles');
            return _context4.abrupt("return", data);
          case 14:
            return _context4.abrupt("return", Promise.reject(message));
          case 15:
            _context4.next = 20;
            break;
          case 17:
            _context4.prev = 17;
            _context4.t0 = _context4["catch"](2);
            return _context4.abrupt("return", Promise.reject('异常：' + _context4.t0));
          case 20:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[2, 17]]);
    }));
    function updateAdminRolePermissions(_x7, _x8) {
      return _updateAdminRolePermissions.apply(this, arguments);
    }
    return updateAdminRolePermissions;
  }()
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};